import threads from "./threads";

export default threads;
